import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { useLocalization } from '@progress/kendo-react-intl';
import { useSchedulerActiveViewContext } from '../../../main';
/** @hidden */
export var ViewSelectorItem = function (props) {
    var _a = useSchedulerActiveViewContext(), activeViewName = _a[0], setActiveViewName = _a[1];
    var localization = useLocalization();
    var title = React.useMemo(function () { return typeof props.view.title === 'function'
        ? props.view.title.call(undefined, localization)
        : props.view.title; }, [props.view.title, localization]);
    var handleClick = React.useCallback(function () { if (props.view.name) {
        setActiveViewName(props.view.name);
    } }, [setActiveViewName, props.view.name]);
    return (React.createElement(Button, { className: 'k-toolbar-button', role: "button", type: "button", tabIndex: -1, togglable: true, selected: props.view.name === activeViewName, onClick: handleClick }, title));
};
